import { render, staticRenderFns } from "./Sign.vue?vue&type=template&id=f6924c52&"
import script from "./Sign.vue?vue&type=script&lang=ts&"
export * from "./Sign.vue?vue&type=script&lang=ts&"
import style0 from "./Sign.vue?vue&type=style&index=0&id=f6924c52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports